import { render, staticRenderFns } from "./Dialogue.vue?vue&type=template&id=100cd5b2&scoped=true&"
import script from "./Dialogue.vue?vue&type=script&lang=js&"
export * from "./Dialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100cd5b2",
  null
  
)

export default component.exports